import { useState } from "react"
import styled from "styled-components"
import Conversaciones from "./Conversaciones"
import Leads from "./Leads"
import Reglas from "./Reglas"
import Pendientes from "./Pendientes"

type Sub = "conv" | "leads" | "reglas" | "pendientes"

export default function Bot() {
    const [sub, setSub] = useState<Sub>("conv")
    return (
        <Wrap>
            <Header>
                <h2>Bot Web</h2>
                <Tabs>
                    <button className={sub === "conv" ? "active" : ""} onClick={() => setSub("conv")}>Conversaciones</button>
                    <button className={sub === "leads" ? "active" : ""} onClick={() => setSub("leads")}>Leads</button>
                    <button className={sub === "reglas" ? "active" : ""} onClick={() => setSub("reglas")}>Reglas</button>
                    <button className={sub === "pendientes" ? "active" : ""} onClick={() => setSub("pendientes")}>Pendientes</button>
                </Tabs>
            </Header>
            <Body>
                {sub === "conv" && <Conversaciones />}
                {sub === "leads" && <Leads />}
                {sub === "reglas" && <Reglas />}
                {sub === "pendientes" && <Pendientes />}
            </Body>
        </Wrap>
    )
}

const Wrap = styled.div`display:flex;flex-direction:column;height:100%;overflow:hidden;`
const Header = styled.div`
display:flex;align-items:center;gap:20px;border-bottom:1px solid #e3ddd2;padding-bottom:10px;margin-bottom:12px;
h2{font-size:20px;color:#2D2318;margin:0;}
`
const Tabs = styled.div`
display:flex;gap:6px;
button{border:none;background:transparent;color:#8B7355;font-size:14px;padding:6px 12px;border-radius:14px;cursor:pointer;}
button.active{background:#C4622D;color:#fff;}
`
const Body = styled.div`flex:1;overflow:hidden;`
